let notificationApi = null;

export const setNotificationApi = (api) => {
  notificationApi = api;
};

export const showNotification = {
  warning: (config) => {
    if (notificationApi) {
      notificationApi.notification.warning(config);
    }
  },
  error: (config) => {
    if (notificationApi) {
      notificationApi.notification.error(config);
    }
  },
  success: (config) => {
    if (notificationApi) {
      notificationApi.notification.success(config);
    }
  },
  info: (config) => {
    if (notificationApi) {
      notificationApi.notification.info(config);
    }
  },
};
